import { makeStyles } from '@material-ui/core/styles';
import {
  Button, GridList, GridListTile,
  MenuItem, Select,
} from '@material-ui/core';
import { Lock, Settings, LocationOn, } from '@material-ui/icons';
import { useDispatch, useSelector, } from "react-redux";

import {
  handleStorageScanManagement,
  handleOpenSettingDialog,
  handleUserManagement,
  handleUserManagementNew
} from '../../../reducers/uiSlice';

import { handleTextFunctionOpen } from '../../../actions/ssmActions';

import { useHistory } from "react-router-dom";
import { userLogout } from '../../../actions/userActions';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useToken } from '../../../utilities/hooks';
import { handleUserManagementAuth } from '../../../actions/userManagementActions';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    height: 'calc(100vh - 40px)'
  },
  label: {
    flexDirection: 'column'
  },
  bottomActionBar: {
    alignContent: 'end',
    marginTop: theme.spacing(2)
  }
}));

export default function ToolbarMenu(props) {
  const { config } = props;
  const classes = useStyles();
  const { t } = useTranslation('menu');
  const dispatch = useDispatch();
  const history = useHistory();
  const tokenContents = useToken();
  const branchList = useSelector(state => state.common.branches);


  const uiAbilities = tokenContents.uiAbilities;
  const authorizedWarehouses = tokenContents.warehouse;
  const branch = +window.localStorage.getItem('user_city');

  const [userAuthOpen, setUserAuthOpen] = useState(false);
  const [pwdType, setPwdType] = useState('');

  const handleWarehouseSwitch = (newWarehouse) => {
    if (newWarehouse !== branch) {
      window.localStorage.setItem('user_city', newWarehouse);

      window.location.reload();
    }
  };

  return (<div className={classes.root}>
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      flex: '0 0 auto',
      alignItems: 'center',
      padding: "0px 0px 5px 0px"
    }}>
      <LocationOn fontSize="small" style={{ padding: 0 }} />
      <Select style={{ padding: "0px 0px 0px 5px" }}
        variant="standard"
        disableUnderline
        IconComponent={() => null}
        onChange={(e) => { handleWarehouseSwitch(e.target.value) }}
        value={branchList.length === 0 ? '' : branch}
      >
        {
          branchList &&
          branchList.filter(
            (branch) => (authorizedWarehouses.includes(branch.id))
          ).map(
            (branch) => (
              <MenuItem key={branch.id} value={branch.id}>
                {branch.name}
              </MenuItem>
            )
          )
        }
      </Select>
    </div>

    <GridList cellHeight='auto'>
      {
        config.map((item) => {
          return (
            isGrantAccess(item.access_ability_id) ?
              <GridListTile key={item.id}>
                <Button
                  id={item.id}
                  classes={{ label: classes.label }}
                  variant='contained'
                  color="secondary"
                  fullWidth
                  onClick={() => handleMenuItemClick(item)}
                  disabled={item.disabled || false}
                  style={{ height: '100%' }}
                >
                  {item.icon}
                  {t(item.title)}
                </Button>
              </GridListTile>
              :
              null
          )
        })
      }
    </GridList>
    {/*Do not remove, This is padding to keep the bottom action bar to the bottom*/}
    <div style={{ flexGrow: 1 }}></div>
    <div className={classes.bottomActionBar}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Button startIcon={<Settings />} onClick={() => dispatch(handleOpenSettingDialog(true))}>
          {t('common:settings')}
        </Button>
        <Button startIcon={<Lock />} onClick={handleLogout}>
          {t('common:logout')}
        </Button>
      </div>
    </div>
  </div>);

  function handleMenuItemClick(route) {
    if (!isGrantAccess(route.access_ability_id))
      return;

    if (isPasswordProtected(route.password_protection || false)) {
      setUserAuthOpen(true);
      setPwdType(route.id);
    }

    if (route.link && route.link.length > 0) {
      history.push(route.link);
      return;
    }

    if (typeof route.dispatchFunction === 'object') {
      dispatch(route.dispatchFunction);
      return;
    }
  }

  function isPasswordProtected(protection) {
    //placeholder method for later
    if (protection) {
      return true;
    } else return false;
  }

  function isGrantAccess(access) {
    return uiAbilities.indexOf(access) !== -1;
  }

  function openHandleUserMngAuth(admin) {
    dispatch(handleUserManagementAuth(admin));
  }

  function openTextPermit(admin, operator) {
    dispatch(handleTextFunctionOpen(admin, operator));
  }

  function handleLogout() {
    userLogout();
  }

  function openUserManagement() {
    dispatch(handleUserManagement(true));
  }

  function openUserManagementNew() {
    dispatch(handleUserManagementNew(true));
  }

  function openStorageScan() {
    dispatch(handleStorageScanManagement(true));
  }

  function handleClose() {
    setUserAuthOpen(false);
  }
}
